import { Button, Flex, Typography } from "antd"

export const SettingsSecurityTourStepUi = () => {
  return (
    <Typography.Text>
      For your security, please enable Two-Factor Authentication (2FA) via
      Google Authenticator in the Settings section. This adds an extra layer of
      protection to your account and helps prevent unauthorized access.
    </Typography.Text>
  )
}
